import classes from './input.module.scss'
import React from 'react';



const Input = (props: any) => {
    const { node, change, data, index } = props;
    const trimData = (evt: any) => {

        if (node.type === 'phone' || node.type === 'phoneNumber') {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            // key = String.fromCharCode(key);
            if ((key >= 48 && key <= 57) || (key === 43 || key === 45 || key === 32)) {
                theEvent.returnValue = true;
            } else {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        }

    }
    const setChange = (value: any) => {
        var decimal = /^\d+(\.\d{1,10})?$/;

        if ((node.type === 'number') || (node.type === 'number' && value !== '')) {

            let updateData = [...data];
            let filter = updateData.filter((n: any) => {
                return n.name === node.name;
            });
            filter[0].value = +value;

            if ('error' in filter[0]) {
                filter[0].error = false;
            }

            change([...updateData])
        }
        if (node.type === 'float' && decimal.test(value + '0') && value !== '') {
            if (!Number.isNaN(parseFloat(value))) {
                let updateData = [...data];
                let filter = updateData.filter((n: any) => {
                    return n.name === node.name;
                });

                filter[0].value = +value;

                if ('error' in filter[0]) {
                    filter[0].error = false;
                }

                change([...updateData])
            }
        }
        else if (node.type !== 'number' && node.type !== 'float' && value !== '') {
            let updateData = [...data];
            let filter: any;
            if (index !== undefined) {
                filter = updateData[index].filter((n: any) => {
                    return n.name === node.name;
                });
            } else {
                filter = updateData.filter((n: any) => {
                    return n.name === node.name;
                });
            }
            if (filter[0]) {
                filter[0].value = value;

                if ('error' in filter[0]) {
                    filter[0].error = false;
                }
            }
            change([...updateData])

        }
        else if (value === '') {
            if (data) {
                let updateData = [...data];

                let filter: any;
                if (index !== undefined) {
                    filter = updateData[index].find((n: any) => {
                        return n.name === node.name
                    });
                } else {
                    filter = updateData.find((n: any) => {
                        return n.name === node.name
                    });
                }

                if (filter) {
                    filter.value = '';

                    if ('error' in filter)
                        filter.error = false;
                }
                change([...updateData])
            }
        }
    }


    return (
        <div className={classes.textGroup}>
            {node.error ? <div style={{color: 'red'}} className={classes.textdesign}>{node.title}</div> : <div className={classes.textdesign}>{node.title}</div>}
            {node.name === 'comment' ? 
                <textarea className={classes.textfields} onKeyPress={(e) => trimData(e)} placeholder={node.placeholder} onChange={(e) => setChange(e.target.value)} value={node.value} rows={4} cols={50} /> : 
                node.error ? <input style={{borderColor: 'red'}} className={node.readOnly ? classes.textfieldReadOnly : classes.textfield} onKeyPress={(e) => trimData(e)} placeholder={node.placeholder} onChange={(e) => setChange(e.target.value)} readOnly={node.readOnly ? true : false} value={node.value} type='text' />:
                <input className={node.readOnly ? classes.textfieldReadOnly : classes.textfield} onKeyPress={(e) => trimData(e)} placeholder={node.placeholder} onChange={(e) => setChange(e.target.value)} readOnly={node.readOnly ? true : false} value={node.value} type='text' />}
        </div>
    )
}

export default Input;